import { render } from "./PeekIntRep.vue?vue&type=template&id=84072e30"
import script from "./PeekIntRep.vue?vue&type=script&lang=js"
export * from "./PeekIntRep.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__